
import { defineComponent } from "vue";
import MapLayerLegend from "@/components/map/MapLayerLegend.vue";
import { LayerControl } from "@/types/LayerControl";
import { useLayout, useMap } from "@/services";
import { mapState } from "pinia";

export default defineComponent({
  name: "MapLegend",
  components: {
    MapLayerLegend,
  },
  computed: {
    activeLayers(): LayerControl[] {
      return (useMap().layerControls as LayerControl[]).filter(
        (l) => l.isVisible
      );
    },
    ...mapState(useLayout, ["drawerHeight"]),
    computedHeight(): (offset?: number) => string {
      return (offset = 0) =>
        `calc(100vh - ${56 - offset}px - ${this.drawerHeight}px)`;
    },
  },
});
